import './embed.scss'
import { useEffect } from 'react'

export default function Embed({ url }) {
  useEffect(() => {
    window.addEventListener(
      'message',
      function(e) {
        var iframe = document.querySelector('.article-embed')
        var eventName = e.data[0]
        var height = e.data[1]
        if (eventName == 'setHeight') {
          iframe.style.height = height + 'px'
        }
      },
      false
    )
  }, [])
  return <iframe className="article-embed" src={url} frameBorder="0" />
}
